<template>
  <div class="container">
    <div class="top">
      <span style="margin-right: 10px">{{ $t("public.bsG") }}：</span>
      <!-- <el-select v-model="stationSlt" placeholder="请选择" size="mini">
        <el-option
          v-for="item in options"
          :key="item.groupId"
          :label="item.groupName"
          :value="item.groupId"
        >
        </el-option>
      </el-select> -->
      <el-select
        v-model="stationSlt"
        :placeholder="$t('public.p8')"
        size="mini"
        @change="stationChange"
      >
        <el-option-group
          v-for="group in options"
          :key="group.groupName"
          :label="group.groupName"
        >
          <el-option
            v-for="item in group.options"
            :key="item.groupId"
            :label="item.groupName"
            :value="item.groupId"
          >
          </el-option>
        </el-option-group>
      </el-select>

      <el-button @click="addGroup" type="" size="mini" style="margin-left: 20px"
        >+{{ $t("public.addG") }}</el-button
      >
      <el-button @click="editGroup" type="primary" size="mini">{{
        $t("public.editG")
      }}</el-button>
      <el-button @click="delGroup" type="danger" size="mini">{{
        $t("public.delG")
      }}</el-button>
      <el-input
        size="mini"
        :placeholder="$t('public.p4')"
        v-model="stationName"
        style="width: 35%; margin-left: 20px"
        @keyup.enter.native="toSearch"
      >
        <template slot="prepend">
          <el-select
            v-model="searchType"
            style="width: 120px"
            @change="selectChange"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="toSearch"
        ></el-button>
      </el-input>
    </div>
    <el-button
      @click="add"
      type="primary"
      size="mini"
      style="width: 100%; margin-top: 5px"
      v-authority="'2-1'"
      >+{{ $t("public.addBS") }}</el-button
    >
    <div class="table">
      <!-- :cell-style="{ padding: '5px' }" -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        ref="table"
        height="100%"
        :empty-text="emptyText"
      >
        <el-table-column
          v-for="(item, index) in column"
          show-overflow-tooltip
          :key="index"
          align="center"
          :prop="column[index].key"
          :label="$t(`public.${column[index].key}`)"
          :width="item.width"
        >
          <template slot-scope="scoped">
            <span
              v-if="item.key == 'status'"
              :style="{
                color:
                  scoped.row[item.key] == 0
                    ? '#e73f32'
                    : scoped.row[item.key] == 1
                    ? '#f9c123'
                    : '#1ed76d',
              }"
            >
              {{ scoped.row[item.key] == 0 ? "×" : "√" }}
            </span>
            <span v-else-if="item.key == 'time'">
              {{ scoped.row[item.key] ? diffTime(scoped.row[item.key]) : "" }}
            </span>
            <span
              v-else
              :style="{
                color:
                  item.key == 'lon' || item.key == 'lat' || item.key == 'data'
                    ? '#2D8CF0'
                    : '',
              }"
            >
              {{
                item.key == "radius"
                  ? scoped.row[item.key] + "km"
                  : scoped.row[item.key]
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('public.option')"
          width="200"
          v-if="showOPt"
        >
          <!-- :width="column.width" -->

          <template slot-scope="scoped">
            <!-- <el-button size="small" type="primary" @click="viewList(scoped.row)"
              >查看列表</el-button
            > -->
            <el-button
              v-authority="'2-2'"
              size="small"
              type="info"
              @click="edit(scoped.row)"
              >{{ $t("public.edit") }}</el-button
            >
            <el-button
              v-authority="'2-3'"
              size="small"
              type="danger"
              @click="del(scoped.row)"
              >{{ $t("public.del") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <viewList
      :show.sync="viewShow"
      :rowInfo="rowInfo"
      :type.sync="type"
    ></viewList>
    <editVue
      @refush="refush"
      :show.sync="editShow"
      :rowInfo.sync="rowInfo"
      :type.sync="type"
    ></editVue>
    <addVue
      :show.sync="addShow"
      :selectGroup.sync="selectGroup"
      :type.sync="type"
      :name.sync="groupName"
      @refush="refush"
    ></addVue>
    <addBaseVue
      :show.sync="addBaseShow"
      :rowInfo.sync="rowInfo"
      :type.sync="type"
      :groups="groups"
      :name.sync="groupName"
      :selectGroup.sync="selectGroup"
      :nextShow.sync="addShow"
      @refush="refush"
      @resetSearch="resetSearch"
    ></addBaseVue>
  </div>
</template>

<script>
import {
  getStations,
  getBaseNames,
  getStaGroupNameList,
  delStation,
  getStaGroupStasList,
} from "@/api/index";
import editVue from "./components/edit.vue";
import viewList from "./components/viewList.vue";
import addVue from "./components/add.vue";
import addBaseVue from "./components/addBase.vue";
export default {
  name: "OverseasStationManageBaseStation",
  components: {
    viewList,
    editVue,
    addVue,
    addBaseVue,
  },
  watch: {
    // groupName: {
    //   handler(newV, oldV){
    //     console.log(newV, "vvvv")
    //   },
    // },
    // addShow: {
    //   handler(newV, oldV){
    //     console.log(newV, "vvvv")
    //   },
    // },
  },
  data() {
    return {
      searchType: "0",
      showOPt: false,
      emptyText: this.$t("public.loading"),
      selectGroup: {},
      groups: [],
      groupName: "", // 组名
      type: "", // 操作类型
      stationName: "",
      options: [
        {
          groupName: this.$t("public.all"),
          options: [
            {
              groupId: "0",
              groupName: this.$t("public.allStation"),
            },
          ],
        },
        {
          groupName: this.$t("public.staG"),
          options: [],
        },
      ],
      stationSlt: "0",
      viewShow: false, // 弹窗
      editShow: false, // 新建基站/编辑基站弹窗
      addShow: false, //
      addBaseShow: false, // 添加基站
      rowInfo: {},
      total: 0,
      pageSize: 10,
      page: 1,
      column: [
        { label: "站点", key: "location", width: "120" },
        { label: "连接信息", key: "connect", width: "180" },
        { label: "状态", key: "status", width: "" },
        { label: "经度", key: "lat", width: "" },
        { label: "纬度", key: "lon", width: "" },
        { label: "半径", key: "radius", width: "100" },
        { label: "卫星数量", key: "num", width: "" },
        { label: "连接时间", key: "time", width: "" },
        { label: "数据量", key: "data", width: "" },
        { label: "挂载用户", key: "user", width: "" },
      ],
      tableData: [],
      allData: [],
      portData: [],
      options1: [
        {
          "label": this.$t("public.stName"),
          "value": "0"
        },
        {
          "label": this.$t("public.stPort"),
          "value": "1"
        }
      ],
    };
  },

  activated() {
    this.getList();
  },
  deactivated() {
    this.page = 1;
  },
  mounted() {
    this.getPermission();
    this.getBsGroup();
  },
  methods: {
    selectChange() {
      this.stationName = ""
      this.toSearch()
    },

    diffTime(time) {
      let t = new Date(time);
      let temp = t.getTime() + this.getLocalTime();
      const dateObj = new Date(temp);
      // 格式化为年-月-日 时:分:秒字符串
      const formattedDateTime = `${dateObj.getFullYear()}-${String(
        dateObj.getMonth() + 1
      ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(
        2,
        "0"
      )} ${String(dateObj.getHours()).padStart(2, "0")}:${String(
        dateObj.getMinutes()
      ).padStart(2, "0")}:${String(dateObj.getSeconds()).padStart(2, "0")}`;
      return formattedDateTime;
    },
    // 返回当地时间和北京时间的时间戳差值
    getLocalTime() {
      let d = new Date();
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60;
      if (time_zone < 0) {
        time_zone = -(Math.abs(time_zone) + 8);
      } else {
        time_zone -= 8;
      }
      // console.log(time_zone, "timmm");
      return time_zone * 60 * 60 * 1000;
    },
    // 是否显示操作栏
    getPermission() {
      const permission = JSON.parse(localStorage.getItem("permission"));
      // console.log(JSON.parse(localStorage.getItem("permission")))
      permission.map((f) => {
        if (f.class == "2-3" || f.class == "2-2") {
          this.showOPt = true;
        }
      });
    },
    refush() {
      this.searchType = "0"
      this.allData = [];
      this.tableData = [];
      this.page = 1;
      this.stationSlt = "0";
      this.getList();
      this.getBsGroup();
    },
    stationChange(e) {
      this.allData = [];
      this.tableData = [];
      this.page = 1;
      if (e == 0) {
        this.getList();
      } else {
        this.getGroupToList();
      }
      // console.log(e, "eeee")
    },
    resetSearch() {},
    getGroupToList() {
      let param = {
        groupId: this.stationSlt,
      };
      getStaGroupStasList(param).then((res) => {
        this.allData = res.data.map((item, index) => {
          return {
            id: index,
            location: item.nm,
            connect: item.ip ? item.ip + ":" + item.po : item.ip,
            status: item.st, // 2 是绿色
            lat: item.la,
            lon: item.lo,
            num: item.sv,
            time: item.lu,
            data:
              item.dn == 0
                ? 0 + "MB"
                : (item.dn / 1024 / 1024).toFixed(2) + "MB",
            user: item.un,
            nm: item.nm,
            ip: item.ip ? item.ip + ":" + item.po : item.ip,
            radius: item.rs,
          };
        });
        // console.log(this.allData, "allllll")
        this.total = this.allData.length;
        this.paging();
      });
    },
    getBsGroup() {
      this.groups = [];
      this.options[1].options = [];
      getStaGroupNameList().then((res) => {
        if (res.data) {
          this.groups = res.data;
          this.options[1].options = [...res.data];
        }
      });
    },
    handleSizeChange() {
      this.paging();
    },
    handleCurrentChange() {
      this.paging();
    },
    paging() {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.page - 1) * this.pageSize;
      // 结束位置 = 当前页 x 每页的大小
      const end = this.page * this.pageSize;
      if(this.searchType == '0'){
        this.tableData = this.allData.slice(start, end);
      } else {
        this.tableData = this.portData.slice(start, end);
      }
      // console.log(this.tableData, start, end);
    },
    getList() {
      let param = {
        stationName: this.stationName,
      };
      getStations(param).then((res) => {
        if (!res.data || !res.data.length || res.data.length == 0) {
          this.emptyText = this.$t("public.noData");
        }
        this.allData = res.data.map((item, index) => {
          return {
            id: index,
            location: item.nm,
            connect: item.ip ? item.ip + ":" + item.po : item.ip,
            port: item.po,
            status: item.st, // 2 是绿色
            lat: item.la,
            lon: item.lo,
            num: item.sv,
            time: item.lu,
            data:
              item.dn == 0
                ? 0 + "MB"
                : (item.dn / 1024 / 1024).toFixed(2) + "MB",
            user: item.un,
            nm: item.nm,
            ip: item.ip ? item.ip + ":" + item.po : item.ip,
            radius: item.rs,
          };
        });
        this.total = this.allData.length;
        this.paging();
      });
    },
    toSearch() {
      this.emptyText = this.$t("public.loading");
      // this.allData = [];
      this.tableData = [];
      this.page = 1;
      this.stationSlt = "0";
      if(this.searchType == "0"){
        this.getList();
      } else {
        this.portData = this.allData.filter(item=>{
          return this.stationName ? String(item.port).includes(this.stationName) : true
        })
        this.paging()
      }
    },
    // 新增分组
    addGroup() {
      this.addShow = true;
    },
    // 编辑分组
    editGroup() {
      this.addBaseShow = true;
    },
    // 删除基站分组
    delGroup() {
      this.addBaseShow = true;
      this.type = "delGroup";
    },
    // 新建基站/编辑基站弹窗
    add() {
      // this.addShow = true;
      this.editShow = true;
    },
    viewList(row) {
      this.viewShow = true;
    },
    edit(row = {}) {
      console.log(row, "row");
      this.editShow = true;
      this.rowInfo = row;
    },
    del(row) {
      this.$confirm(this.$t("public.sureDelBS"), this.$t("public.tip"), {
        confirmButtonText: this.$t("public.submit"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      })
        .then(() => {
          let param = { sta: row.nm };
          delStation(param).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.$t("public.success3"));
              this.getList();
            }
          });
        })
        .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          //   });
          return;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  align-items: center;
}
.table {
  height: calc(100% - 30px - 32px - 48px);
  // margin-top: 10px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep {
  .table th.el-table__cell {
    background-color: #3e916a;
    color: #fff;
    border: none;
  }
}
</style>
